import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49eec9f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "styles" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p data-v-49eec9f0>This page displays a preview of this applications style and components</p><section data-v-49eec9f0><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Typography</h4><div class=\"column\" data-v-49eec9f0><div data-v-49eec9f0><h1 data-v-49eec9f0>h1 heading-xl</h1><h2 data-v-49eec9f0>h2 headling-lg</h2><h3 data-v-49eec9f0>h3 heading-md</h3><h4 data-v-49eec9f0>h4 heading-sm</h4><h5 data-v-49eec9f0>h5/h6 heading-xs</h5></div></div><div class=\"column\" data-v-49eec9f0><div data-v-49eec9f0>default</div><div data-v-49eec9f0><strong data-v-49eec9f0>default-strong</strong></div><div data-v-49eec9f0><a href=\"/styles\" data-v-49eec9f0>default-link</a></div><input value=\"default-input\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>action label</div><div class=\"small\" data-v-49eec9f0>small</div><div data-v-49eec9f0><a class=\"small\" href=\"/styles\" data-v-49eec9f0>small-link</a></div></div></div></section><section data-v-49eec9f0><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Primary</h4><div class=\"column center\" data-v-49eec9f0><div class=\"circle primary elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>primary</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle primary-400 elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>primary-400</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle primary-300 elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>primary-300</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle primary-200 elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>primary-200</span></div></div><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Secondary</h4><div class=\"column center\" data-v-49eec9f0><div class=\"circle cool-dark elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>cool-dark</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle cool-medium elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>cool-medium</span></div></div><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Accent</h4><div class=\"column center\" data-v-49eec9f0><div class=\"circle warm-dark elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>warm-dark</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle warm-medium elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>warm-medium</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle warm-light elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>warm-light</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle cool-light elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>cool-light</span></div></div><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Neutral</h4><div class=\"column center\" data-v-49eec9f0><div class=\"circle black elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>black</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle dark elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>dark</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle medium elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>medium</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle outline elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>outline</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle light elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>light</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle white elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>white</span></div></div></section><section data-v-49eec9f0><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Elevation</h4><div class=\"column center\" data-v-49eec9f0><div class=\"circle elevation1\" data-v-49eec9f0></div><span data-v-49eec9f0>elevation 1</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle elevation2\" data-v-49eec9f0></div><span data-v-49eec9f0>elevation 2</span></div><div class=\"column center\" data-v-49eec9f0><div class=\"circle elevation3\" data-v-49eec9f0></div><span data-v-49eec9f0>elevation 3</span></div></div></section><section data-v-49eec9f0><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Ghost</h4><div class=\"column center\" data-v-49eec9f0><button class=\"btn-ghost\" data-v-49eec9f0>Default</button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-ghost\" aria-disabled=\"true\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Disabled</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-ghost focus\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Focus</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-ghost hover\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Hover</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-ghost active\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Pressed</div></button></div></div></section>", 5)
const _hoisted_7 = { class: "row elevation1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Buttons Primary", -1))
const _hoisted_9 = { class: "column center" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"column center\" data-v-49eec9f0><button class=\"btn-primary\" aria-disabled=\"true\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Disabled</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-primary focus\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Focus</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-primary hover\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Hover</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-primary active\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Pressed</div></button></div>", 4)
const _hoisted_14 = { class: "row elevation1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Buttons Secondary", -1))
const _hoisted_16 = { class: "column center" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"column center\" data-v-49eec9f0><button class=\"btn-secondary\" aria-disabled=\"true\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Disabled</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-secondary focus\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Focus</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-secondary hover\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Hover</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-secondary active\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Pressed</div></button></div>", 4)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<section data-v-49eec9f0><div class=\"row elevation1\" data-v-49eec9f0><h4 data-v-49eec9f0>Buttons Tertiary</h4><div class=\"column center\" data-v-49eec9f0><button class=\"btn-tertiary\" data-v-49eec9f0>Default</button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-tertiary\" aria-disabled=\"true\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Disabled</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-tertiary focus\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Focus</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-tertiary hover\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Hover</div></button></div><div class=\"column center\" data-v-49eec9f0><button class=\"btn-tertiary active\" data-v-49eec9f0><div class=\"action-label\" data-v-49eec9f0>Pressed</div></button></div></div></section>", 1)
const _hoisted_22 = { class: "row elevation1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Checkbox", -1))
const _hoisted_24 = { class: "column center" }
const _hoisted_25 = { class: "column center" }
const _hoisted_26 = { class: "column center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "checkbox-focus",
      type: "checkbox"
    }),
    /*#__PURE__*/_createElementVNode("label", null, "Focus")
  ])
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "checkbox-hover",
      type: "checkbox"
    }),
    /*#__PURE__*/_createElementVNode("label", null, "Hover")
  ])
], -1))
const _hoisted_29 = { class: "row elevation1" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Radio", -1))
const _hoisted_31 = { class: "column center" }
const _hoisted_32 = { class: "column center" }
const _hoisted_33 = { class: "column center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "radio-focus",
      type: "radio",
      value: "focus"
    }),
    /*#__PURE__*/_createElementVNode("label", null, "Focus")
  ])
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "radio-hover",
      type: "radio",
      value: "hover"
    }),
    /*#__PURE__*/_createElementVNode("label", null, "Hover")
  ])
], -1))
const _hoisted_36 = { class: "row elevation1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Input", -1))
const _hoisted_38 = { class: "column center" }
const _hoisted_39 = { class: "column center" }
const _hoisted_40 = { class: "column center" }
const _hoisted_41 = { class: "row elevation1" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Notifications", -1))
const _hoisted_43 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseInputCheckbox = _resolveComponent("BaseInputCheckbox")!
  const _component_BaseInputRadio = _resolveComponent("BaseInputRadio")!
  const _component_BaseInputText = _resolveComponent("BaseInputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BrandLogo, {
      class: "logo",
      role: "img",
      "aria-label": _ctx.$t('logoDescription')
    }, null, 8, ["aria-label"]),
    _hoisted_2,
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_BaseButton, null, {
            default: _withCtx(() => [
              _createTextVNode("Default")
            ]),
            _: 1
          })
        ]),
        _hoisted_10
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_BaseButton, { class: "btn-secondary" }, {
            default: _withCtx(() => [
              _createTextVNode("Default")
            ]),
            _: 1
          })
        ]),
        _hoisted_17
      ])
    ]),
    _hoisted_21,
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_BaseInputCheckbox, {
            inputName: "checkboxDefault",
            labelText: "Default"
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_BaseInputCheckbox, {
            inputName: "checkboxChecked",
            labelText: "Checked",
            inputModel: _ctx.radioChecked,
            "onUpdate:inputModel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.radioChecked = $event))
          }, null, 8, ["inputModel"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_BaseInputCheckbox, {
            inputName: "checkboxDisabled",
            labelText: "Disabled",
            disabled: true
          })
        ]),
        _hoisted_27,
        _hoisted_28
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_BaseInputRadio, {
            inputId: "0",
            inputName: "radioDefault",
            value: "default",
            labelText: "Default",
            inputModel: _ctx.radioSelected,
            "onUpdate:inputModel": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioSelected = $event))
          }, null, 8, ["inputModel"])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_BaseInputRadio, {
            inputId: "1",
            inputName: "radioSelected",
            value: "selected",
            labelText: "Selected",
            inputModel: _ctx.radioSelected,
            "onUpdate:inputModel": _cache[2] || (_cache[2] = ($event: any) => (_ctx.radioSelected = $event))
          }, null, 8, ["inputModel"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_BaseInputRadio, {
            inputId: "2",
            inputName: "radioDisabled",
            value: "disabled",
            labelText: "Disabled",
            disabled: true
          })
        ]),
        _hoisted_34,
        _hoisted_35
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_BaseInputText, {
            labelText: "Label Top",
            inputName: "input",
            labelLocation: "top",
            inputModel: _ctx.inputText,
            "onUpdate:inputModel": _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputText = $event))
          }, null, 8, ["inputModel"])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_BaseInputText, {
            labelText: "Label Left",
            inputName: "input2",
            inputModel: _ctx.inputText,
            "onUpdate:inputModel": _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputText = $event))
          }, null, 8, ["inputModel"])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_BaseInputText, {
            labelText: "Disabled",
            inputName: "input3",
            disabled: true
          })
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createVNode(_component_BaseInputText, {
          labelText: "Header",
          inputName: "header",
          inputModel: _ctx.notificationHeader,
          "onUpdate:inputModel": _cache[5] || (_cache[5] = ($event: any) => (_ctx.notificationHeader = $event))
        }, null, 8, ["inputModel"]),
        _createVNode(_component_BaseInputText, {
          labelText: "Description",
          inputName: "description",
          inputModel: _ctx.notificationDescription,
          "onUpdate:inputModel": _cache[6] || (_cache[6] = ($event: any) => (_ctx.notificationDescription = $event))
        }, null, 8, ["inputModel"]),
        _createElementVNode("div", _hoisted_43, [
          _createVNode(_component_BaseButton, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showInfoNotification()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Show info notification")
            ]),
            _: 1
          }),
          _createVNode(_component_BaseButton, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showWarningNotification()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Show warning notification")
            ]),
            _: 1
          }),
          _createVNode(_component_BaseButton, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showErrorNotification()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Show error notification")
            ]),
            _: 1
          }),
          _createVNode(_component_BaseButton, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSuccessNotification()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Show success notification")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}